import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-checkmark.tsx
/**
* icon.16.checkmark
*
* Keywords: check, tick, confirm, approval, verify, correct, success, complete
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjA4OCAzLjIxN2EuNS41IDAgMCAxIC44MjQuNTY2bC01LjUgOGEuNS41IDAgMCAxLS43ODguMDQ2bC0zLjUtNGEuNS41IDAgMSAxIC43NTItLjY1OGwzLjA3NiAzLjUxNXoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=286-5632
*/
const Icon16Checkmark = memo(function Icon16Checkmark(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.088 3.217a.5.5 0 0 1 .824.566l-5.5 8a.5.5 0 0 1-.788.046l-3.5-4a.5.5 0 1 1 .752-.658l3.076 3.515z"
		})
	});
});
//#endregion
export { Icon16Checkmark };

//# sourceMappingURL=icon-16-checkmark.js.map